import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SearchableNavItem } from '../utils/navigationSearch';

interface CommandPaletteResultItemProps {
  item: SearchableNavItem;
  isSelected: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}

export const CommandPaletteResultItem: React.FC<
  CommandPaletteResultItemProps
> = ({ item, isSelected, onClick, onMouseEnter }) => {
  const IconComponent = item.icon;

  return (
    <ListItem
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      data-testid={`command-palette-item-${item.text.toLowerCase().replace(/\s+/g, '-')}`}
      sx={{
        height: 56,
        px: 2,
        borderRadius: 1,
        mb: 0.5,
        cursor: 'pointer',
        bgcolor: isSelected
          ? theme =>
              theme.palette.mode === 'dark'
                ? 'rgba(245, 158, 11, 0.15)'
                : 'rgba(245, 158, 11, 0.08)'
          : 'transparent',
        '&:hover': {
          bgcolor: theme =>
            theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.08)'
              : 'rgba(0, 0, 0, 0.04)',
        },
        transition: 'background-color 0.15s ease',
      }}
    >
      {/* Icon */}
      <ListItemIcon
        sx={{
          minWidth: 40,
          color: isSelected ? 'primary.main' : 'text.secondary',
        }}
      >
        <IconComponent sx={{ fontSize: 24 }} />
      </ListItemIcon>

      {/* Text content */}
      <ListItemText
        primary={
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              fontSize: '15px',
              color: isSelected ? 'primary.main' : 'text.primary',
            }}
          >
            {item.text}
          </Box>
        }
        secondary={
          item.parent && (
            <Box
              component="span"
              sx={{
                fontSize: '13px',
                color: 'text.secondary',
              }}
            >
              {item.parent}
            </Box>
          )
        }
      />

      {/* Right arrow indicator */}
      <ChevronRightIcon
        sx={{
          fontSize: 20,
          color: isSelected ? 'primary.main' : 'text.disabled',
          opacity: isSelected ? 1 : 0,
          transition: 'opacity 0.15s ease',
        }}
      />
    </ListItem>
  );
};
